const inputTypes = {
  TEXT: "ECore.Def.DefEnums.itText",
  SELECT: "ECore.Def.DefEnums.itSelect",
  MULTI_SELECT: "ECore.Def.DefEnums.itMultiSelect",
  AUTO_COMPLETE: "ECore.Def.DefEnums.itAutoComplete",
  RISKID_SELECTOR : "ECore.Def.DefEnums.itRiskIdSelector",
  MULTI_AUTO_COMPLETE: "ECore.Def.DefEnums.itMultiAutoComplete",
  LOCAL_DATE: "ECore.Def.DefEnums.itLocalDate",
  DATEANDTIME:"ECore.Def.DefEnums.itDateAndTime",
  GLOBAL_DATE: "ECore.Def.DefEnums.itGlobalDate",
  SWITCH: "ECore.Def.DefEnums.itSwitch",
  RADIO: "ECore.Def.DefEnums.itRadio",
  CHECKBOX: "ECore.Def.DefEnums.itCheckBox",
  TIME: "ECore.Def.DefEnums.itTime",
  FILE: "ECore.Def.DefEnums.itFile",
  TEXT_AREA: "ECore.Def.DefEnums.itTextArea",
  TREE_SELECT: "ECore.Def.DefEnums.itTreeSelect",
  EXT_SWITCH: "ECore.Def.DefEnums.itExtSwitch",
  EXT_TEXT: "ECore.Def.DefEnums.itExtText",
  MULTI_CHECK_BOX : "ECore.Def.DefEnums.itMultiCheckbox",
  MULTI_RADIO : "ECore.Def.DefEnums.itMultiRadio",
  DEF : "ECore.Def.DefEnums.itDef",
  MONEY: "ECore.Def.DefEnums.itMoney",
  SELECT_INTO : "ECore.Def.DefEnums.itSelectInto"
};

const dispConvertType = {
  YEAR_TO_DATE : 'ECore.Def.DefEnums.dctYearToDate',
  DIGITS_TO_MONEY : 'ECore.Def.DefEnums.dctDigitsToMoney',
  PERCENT_TO_NUMBER : 'ECore.Def.DefEnums.dctPercentToNumber',
  REMOVE_NUM_FROM_STRING: 'ECore.Def.DefEnums.dctRemoveNumFromString'
}

const formModes = {
  CREATE: "ECore.Def.DefEnums.fmCreate",
  DELETE: "ECore.Def.DefEnums.fmDelete",
  EDIT: "ECore.Def.DefEnums.fmEdit",
  VIEW: "ECore.Def.DefEnums.fmView",
};

const formActionLacations = {
  FOOTER: "ECore.Def.DefEnums.Footer",
  HEADER: "ECore.Def.DefEnums.Header"
};

const pageLayouts = {
  SECTION: "ECore.Def.DefEnums.plSection",
  SEARCH: "ECore.Def.DefEnums.plSearch",
  CUSTOM: "ECore.Def.DefEnums.plCustom",
};

const validationPresets = {
  REQUIRED: "ECore.Def.DefEnums.prvRequired"
};

const actionTargets = {
  MODAL: "ECore.Def.DefEnums.atModal",
  PAGE: "ECore.Def.DefEnums.atPage",
};

const actionTypes = {
  ACTION_LIST: "ECore.Def.DefEnums.atActionList"
};

const formActions = {
  SUBMIT: "ECore.Def.DefEnums.fcaSubmitButton",
  CANCEL: "ECore.Def.DefEnums.fcaCancelButton"
};

const exprLanguage = {
  JAVASCRIPT: "ECore.Def.DefEnums.slJavaScript"
};

const lookupCacheStrategies = {
  WHOLE: "ECore.Def.DefEnums.ccWhole",
  NONE: "ECore.Def.DefEnums.ccNone"
};

const lookupMethods = {
  SERVER_AUTO_COMPLETE: "ECore.Def.DefEnums.lmServerAutoComplete"
}

const modalResults = {
  SUBMIT: "ECore.Def.DefEnums.mrSubmit",
  CANCEL: "ECore.Def.DefEnums.mrCancel",
  YES: "ECore.Def.DefEnums.mrYes",
  NO: "ECore.Def.DefEnums.mrNO",
};

const ACTION_TAG = Object.freeze({
  KEEP_DIALOG_OPEN: 'keepOpen',
   STAY_IN_STEP: 'stay_in_step'
});

const printReportTemplates = Object.freeze({
  main: "main",
  termdisablement: "termdisablement",
  financialsituation: "financialsituation",
  pensiontables: "pensiontables"
});

export {
  inputTypes,
  formModes,
  formActionLacations,
  pageLayouts,
  validationPresets,
  actionTargets,
  actionTypes,
  formActions,
  exprLanguage,
  lookupCacheStrategies,
  lookupMethods,
  modalResults,
  dispConvertType,
  ACTION_TAG,
  printReportTemplates
}